export default [
  {
    path: '/stored-card-activity',
    name: 'stored-card-activity',
    component: () => import(/* webpackChunkName: "stored-card-activity" */ './stored-card-activity/stored-card-activity.vue'),
    meta: {
      menuCode: 'storedCardActivity',
      menuName: '储值卡活动',
    },
  },
  {
    path: '/stored-card-mgr-list',
    name: 'stored-card-mgr-list',
    component: () => import(/* webpackChunkName: "stored-card-mgr-list" */ './stored-card-mgr/stored-card-mgr-list.vue'),
    meta: {
      menuCode: 'storedCardList',
      menuName: '储值卡管理',
    },
  },
  {
    path: '/stored-card-mgr-detail',
    name: 'stored-card-mgr-detail',
    component: () => import(/* webpackChunkName: "stored-card-mgr-detail" */ './stored-card-mgr/stored-card-mgr-detail.vue'),
    meta: {
      menuName: '储值卡详情',
    },
  },
  {
    path: '/stored-card-activity-add',
    name: 'stored-card-activity-add',
    component: () => import(/* webpackChunkName: "stored-card-activity-add" */ './stored-card-activity/stored-card-activity-add.vue'),
    meta: {
      // menuCode: 'storedCardActivity',
      menuName: '新增储值卡活动',
    },
  },
];
